/**
 * Returns true if a permission is enabled in a permission set.
 * @param permissionSet The permission set to check against
 * @param permissionToCheck The permission to check
 */ export function isFlagPermissionEnabled(permissionSet, permissionToCheck) {
    return (permissionSet & permissionToCheck) !== 0;
}
